<template>
	<div>
		<colikado-summary-by-product-type />
		<colipays-summary-by-product-type />
		<summary-by-reception-type />
		<summary-graph />
	</div>
</template>

<script>
	import SummaryByReceptionType from './_components/summary-by-reception-type';
	import ColikadoSummaryByProductType from './_components/colikado-summary-by-product-type';
	import SummaryGraph from './_components/summary-graph';
	import ColipaysSummaryByProductType from '@/views/_components/colipays-summary-by-product-type';
	export default {
		name: 'Dashboard',
		components: {
			ColipaysSummaryByProductType,
			SummaryGraph,
			ColikadoSummaryByProductType,
			SummaryByReceptionType,
		},
		data() {
			return {};
		},
	};
</script>
